import { casinoStoreKeys } from '../casinoStoreConstants'
import { useSetCasinoData } from '../hooks'

export const useSetCasinoGameCabinetStaticUi = () => {
  const { setCasinoData } = useSetCasinoData()
  const setCasinoGameCabinetStaticUi = casinoGameCabinetStaticUi => {
    setCasinoData(
      { [casinoStoreKeys.casinoGameCabinetStaticUi]: casinoGameCabinetStaticUi },
      'setCasinoGameCabinetStaticUi'
    )
  }
  return { setCasinoGameCabinetStaticUi }
}
